import {
  Component,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-tank-volume-level-chart',
  templateUrl: './tank-volume-level-chart.component.html',
  styleUrls: ['./tank-volume-level-chart.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TankVolumeLevelChartComponent {
  @Input()
  public fillColor: string | null = null;

  @Input() public height: string = '156px';

  private _tankLevelPercent: number | null = null;
  public get tankLevelPercent(): number | null {
    return this._tankLevelPercent;
  }
  @Input()
  public set tankLevelPercent(volume: number | null) {
    this._tankLevelPercent = volume;
    this.cdr.detectChanges();
  }

  private _showVolumeLevelLabels: boolean = true;
  public get showVolumeLevelLabels(): boolean {
    return this._showVolumeLevelLabels;
  }
  @Input()
  public set showVolumeLevelLabels(value: boolean) {
    this._showVolumeLevelLabels = value;
    this.cdr.detectChanges();
  }

  @Input()
  tankCapacity: number = 0;

  @Input()
  volumeSuffix: string = '';

  constructor(private cdr: ChangeDetectorRef) {}
}
